import {
  WHEELBUILDER_RECEIVE_ERROR,
  WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL,
  WHEELBUILDER_SET_CURRENT_STEP,
  WHEELBUILDER_SET_PRODUCT_QUANTITY,
  WHEELBUILDER_SET_SELECTED_PRODUCT,
  WHEELBUILDER_SET_SELECTED_RIM,
  WHEELBUILDER_RECEIVE_TPMS_SENSORS,
  WHEELBUILDER_RESET_REGNO_STEP,
  WHEELBUILDER_RECEIVE_TIRES,
  WHEELBUILDER_RECEIVE_SUMMARY,
  WHEELBUILDER_SET_ASSEMBLY_CHECKED,
  WHEELBUILDER_RECEIVE_PAYLOAD,
  WHEELBUILDER_SET_PAGINATION,
  WHEELBUILDER_SET_BLACK_VALVE_CHECKED,
  WHEELBUILDER_SET_IS_LOADING,
} from '../constants';
import { create as createGuid } from 'guid';

export const DEFAULT_WHEEL_BUILDER_STATE = {
  sessionId: createGuid(),
  regNo: '',
  rims: [],
  wheels: [],
  tpmsSensors: [],
  carModel: null,
  selectedRim: null,
  selectedTire: null,
  selectedTpmsSensor: null,
  currentStep: 1,
  quantity: 4,
  tpmsInformation: null,
  isLoading: false,
  assemblyChecked: false,
  assemblyCost: null,
  blackValveChecked: false,
  blackValveCost: null,
  error: null,
  userIsAuthenticated: false,
  pagination: null,
  carModelVariants: [],
  selectedCarModelVariantSystemId: null,
};

export const wheelBuilder = (state = DEFAULT_WHEEL_BUILDER_STATE, action) => {
  switch (action.type) {
    case WHEELBUILDER_SET_SELECTED_RIM:
    case WHEELBUILDER_RECEIVE_RIMS_AND_CAR_MODEL:
    case WHEELBUILDER_RECEIVE_ERROR:
    case WHEELBUILDER_SET_SELECTED_PRODUCT:
    case WHEELBUILDER_SET_CURRENT_STEP:
    case WHEELBUILDER_SET_PRODUCT_QUANTITY:
    case WHEELBUILDER_RECEIVE_TPMS_SENSORS:
    case WHEELBUILDER_RESET_REGNO_STEP:
    case WHEELBUILDER_RECEIVE_TIRES:
    case WHEELBUILDER_RECEIVE_SUMMARY:
    case WHEELBUILDER_SET_ASSEMBLY_CHECKED:
    case WHEELBUILDER_RECEIVE_PAYLOAD:
    case WHEELBUILDER_SET_PAGINATION:
    case WHEELBUILDER_SET_BLACK_VALVE_CHECKED:
    case WHEELBUILDER_SET_IS_LOADING:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
